import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Switch, Route } from 'react-router-dom'
import { FormattedDate } from 'react-intl'
import Icon from 'components/Icon'
import { Full as Loading } from 'components/Loading'
import useApi from 'hooks/useApi'
import OrderDetailsPane from 'containers/CustomerOrdersPage/components/OrderDetailsPane'

import TemplateList from './../../components/TemplateList'
import Template from './../../components/Template'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import useCurrentUser from 'hooks/useCurrentUser'

const InsertPage = ({ location: { state = {} }, history, match: { params: { template: slug } } }) => {
  const [templates, loading, errors] = useApi('/rest/v2/template')
  const { id } = useCurrentUser()

  const onUpserted = (promise) => {
    promise.then(({ success, meta: { id, template } }) => {
      if (success) {
        history.push(`/orders/${id}`)
      }
    })
  }

  const [template, orderId] = useMemo(() => {
    if (state && state.attributes) {
      return [state, state.meta.orderId]
    }

    if (templates) {
      return [templates.find(({ meta: { hashId } }) => hashId === slug), null]
    }

    return [null, null]
  }, [state, templates])

  const attributes = useMemo(() => {
    if (!template) {
      return {}
    }

    let { name, ...attrs } = template.meta

    template.attributes.forEach((attr) => {
      if (attr.key === 'contact') {
        attrs[attr.key] = id
      }
    })

    return attrs
  }, [template, id])

  return (
    <div className="w-full h-full flex flex-col sm:flex-row">
      <div className={`${!orderId ? 'w-full' : 'w-full md:w-1/2 lg:w-2/3'} flex flex-col h-full py-3 px-4 lg:py-5 lg:px-6 space-y-6`}>
        <div className="pb-5 border-b border-gray-200">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            <FormattedMessage{...messages.fillDetailsTitle}/>
          </h3>
          <p className="mt-2 max-w-4xl text-sm text-gray-500"><FormattedMessage{...messages.fillDetailsBody}/></p>
        </div>
        <div className="grow overflow-x-scroll w-full">
          { loading || !templates ? (
            <Loading children={errors || undefined} />
          ) : (
            <Template
              template={template}
              onUpserted={onUpserted}
              attributes={attributes}
            />
          ) }
        </div>
      </div>
      { !!orderId &&
        <div className="w-full md:w-1/2 lg:w-1/3 h-full flex flex-col border-l border-gray-100">
          <OrderDetailsPane order={{ uid: orderId }} />
        </div>
      }
    </div>
  )
}

export default InsertPage

